import React, { useEffect, useState } from "react";
import { createStyles, makeStyles } from "@material-ui/core";
import IndexContainer from "../../../src/components/index-container";
import SignupRealEstate from "../../../src/pages/signup-realestate";
import realEstateService from "../../../src/store/services/real-estate.service";
import { useRouter } from "next/router";

const useStyles = makeStyles(theme =>
    createStyles({
        footerClassName: {
            [theme.breakpoints.down("sm")]: {
                position: "relative"
            }
        }
    })
);

export default function ProspectiveBuyer() {
    if (typeof window === "undefined") return <div />;

    const classes = useStyles();
    const router = useRouter();

    const [loading, setIsLoading] = useState(false);
    const [props, setProps] = useState(undefined);

    useEffect(() => {
        const documentId = router.query?.realEstateId;
        if (!props && documentId) {
            (async () => {
                setIsLoading(true);
                const response = await realEstateService.getInitialRealEstate(documentId);
                setProps(response.data.props);
                setIsLoading(false);
            })();
        }
    }, [router.query]);

    return (
        <IndexContainer logo={props?.props?.workspace?.extras?.logo?.src} footerClassName={classes.footerClassName}>
            <SignupRealEstate {...props} />
        </IndexContainer>
    );
}

// export const getServerSideProps: GetServerSideProps = async ctx => {
//     return await buildIndexProps(ctx);
// };
